<template>
    <el-dialog :title="title"
               width="40%"
               :visible="showDialog"
               @open="create"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               append-to-body
               :show-close="false">
        <div class="row">
            <div class="col-md-12" style="margin-top: 8px">
                <x-input label="Buscar lote"
                         v-model="searchLotsGroup"
                         @input="changeSearchLotsGroup"></x-input>
            </div>
            <div class="col-md-12">
                <div style="width: 100%">Cantidad seleccionada: {{ quantity }}</div>
            </div>
            <div class="col-md-12" v-loading="loading">
                <div class="table-responsive mt-3">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="text-center">#</th>
                            <th class="text-center">Seleccionar</th>
                            <th v-if="lotsGroup.length > 0">Código</th>
                            <th>Cantidad</th>
                            <th class="text-center">F.Vencimiento</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(row, index) in lotsGroup" :key="index">
                            <td class="text-center">
                                {{ index + 1 }}
                            </td>
                            <td class="text-center">
                                <el-input-number v-model="row.compromise_quantity"
                                                 :min="0"
                                                 :max="row.quantity"
                                                 @change="changeCompromiseQuantity(row)"></el-input-number>
                            </td>
                            <td>
                                {{ row.code }}
                            </td>
                            <td>
                                {{ row.quantity }}
                            </td>
                            <td class="text-center">
                                {{ row.date_of_due }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 text-right" style="margin-top: 16px">
                <el-button @click.prevent="close">Cerrar</el-button>
                <el-button type="primary"
                           :disabled="quantity <= 0"
                           @click="submit">Aceptar
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

import XSelect from "../../../../components/Form/XSelect.vue"
import XInput from "../../../../components/Form/XInput.vue"

export default {
    name: 'LotsGroupList',
    components: {XInput, XSelect},
    props: ['showDialog', 'item', 'warehouseId', 'selectedLotsGroup'],
    data() {
        return {
            title: 'Seleccionar lotes',
            loading: false,
            errors: {},
            form: {},
            lotsGroup: [],
            allLotsGroup: [],
            lotsGroupSelected: [],
            searchLotsGroup: '',
            quantity: 0
        }
    },
    methods: {
        async create() {
            console.log('create')
            this.initForm()
            this.lotsGroupSelected = this.selectedLotsGroup ? this.selectedLotsGroup : []
            await this.initTables()
            this.changeLotsGroup()
        },
        initForm() {
            console.log('initForm')
            this.allLotsGroup = []
            this.lotsGroupSelected = []
            this.searchLotsGroup = ''
        },
        async initTables() {
            console.log('initTables')
            this.loading = true
            await this.$http.post(`/documents/item_lots_group`, {
                item_id: this.item.id
            })
                .then((response) => {
                    this.allLotsGroup = response.data
                })
                .catch(error => {
                })
                .then(() => {
                    this.loading = false
                })
        },
        changeLotsGroup() {
            console.log('changeLotsGroup')
            this.lotsGroup = []
            this.allLotsGroup.forEach(row => {
                let exist = true
                if (this.lotsGroupSelected.length > 0) {
                    let lg = this.lotsGroupSelected.find(lot => lot.id === row.id)
                    if (lg) {
                        row.compromise_quantity = parseFloat(lg.compromise_quantity)
                    }
                }
                if (this.searchLotsGroup !== '' && exist) {
                    exist = row.code.toLowerCase().includes(this.searchLotsGroup.toLowerCase())
                }
                if (exist) {
                    this.lotsGroup.push({
                        id: row.id,
                        compromise_quantity: row.compromise_quantity,
                        code: row.code,
                        quantity: row.quantity,
                        date_of_due: row.date_of_due,
                    })
                }
            })
            this.calculateQuantity()
        },
        changeSearchLotsGroup() {
            console.log('changeSearchLotsGroup')
            this.changeLotsGroup()
        },
        changeCompromiseQuantity(row) {
            console.log('changeCompromiseQuantity')
            let indexGroup = this.allLotsGroup.findIndex(g => g.id === row.id)
            if (indexGroup > -1) {
                this.allLotsGroup[indexGroup].compromise_quantity = row.compromise_quantity
            }
            this.calculateQuantity()
        },
        calculateQuantity() {
            console.log('calculateQuantity')
            let q = 0
            this.allLotsGroup.forEach(l => {
                q += parseFloat(l.compromise_quantity)
            })
            this.quantity = q
        },
        submit() {
            console.log('submit')
            let dataLotsGroup = []
            this.allLotsGroup.forEach(row => {
                if (row.compromise_quantity > 0) {
                    dataLotsGroup.push(row)
                }
            })
            this.$emit('success', {
                lotsGroup: dataLotsGroup,
                quantity: this.quantity
            })
            this.close()
        },
        close() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>
